var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col w-full h-full"},[_c('iframe',{attrs:{"src":_vm.url,"width":"100%","height":"100%"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }